<template>
    <v-layout align-center justify-space-between class="channel-filter-container">
        <v-icon @click="back" :color="shouldShowBack ? '#fff' : 'transparent'" :class="{active: shouldShowBack}">mdi-chevron-left</v-icon>
        <v-layout align-center style="overflow: hidden; height: 70px">
            <div
                v-for="channel in visibleChannelList"
                :key="channel"
                class="channel"
                :class="{active: activeChannel === channel}"
                @click="selectChannel(channel)"
            >
                <div style="width:100%;padding: 0 3px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    <img style="width: 32px; border-radius: 100%" :src="'/assets/icons/platform/'+channel+'.svg'" :alt="channel">
                    <br>
                    <v-tooltip bottom :disabled="$t(channel).length < 9">
                        <span slot="activator">{{ $t(channel) }}</span>
                        <span>{{ $t(channel) }}</span>
                    </v-tooltip>
                </div>
            </div>
        </v-layout>
        <v-icon @click="next" :color="shouldShowNext ? '#fff' : 'transparent'" :class="{active: shouldShowNext}">mdi-chevron-right</v-icon>
    </v-layout>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "ChannelFilter",
    props: {
        channelList: {
            type: Array,
            default: () => []
        },
        activeChannel: {
            type: String,
            default: ''
        },
        selectChannel: {
            type: Function,
            default: () => {
            }
        }
    },
    data () {
        return {
            startChannelIndex: 0
        }
    },
    computed: {
        ...mapState({
            numberOfVisibleChannel: state => state.isSmallScreen ? 5 : 5
        }),
        visibleChannelList () {
            return this.channelList.slice(this.startChannelIndex, this.startChannelIndex + this.numberOfVisibleChannel)
        },
        shouldShowBack () {
            return this.startChannelIndex !== 0
        },
        shouldShowNext () {
            return this.startChannelIndex + this.numberOfVisibleChannel < this.channelList.length
        }
    },
    methods: {
        next () {
            this.startChannelIndex++;
        },
        back () {
            if (this.startChannelIndex > 0) {
                this.startChannelIndex--;
            }
        }
    },
    watch: {
        numberOfVisibleChannel () {
            if (this.numberOfVisibleChannel >= this.channelList.length) {
                this.startChannelIndex = 0
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .channel-filter-container {
        background: #004BBA;
        height: 70px;
        display: grid;
        grid-template-columns: auto 1fr auto;
    }

    .channel-filter-container .channel:last-child {
        margin-right: 0;
    }

    .channel {
        flex: 0 0 70px;
        width: 70px;
        height: 70px;
        text-align: center;
        color: #fff;
        text-transform: capitalize;
        font-size: 12px;
        cursor: pointer;
        display: grid;
        place-items: center;

        i {
            text-transform: none; // for error icon in firefox
        }

        &.active {
            background: #F7F7FC;
            color: #000;
        }
    }

    ::v-deep .v-icon {
        /*opacity: 0.34;*/
        pointer-events: none;

        &.active {
            opacity: 1;
            pointer-events: visible;
        }
    }
</style>
